module.exports = __webpack_public_path__ + "img/more-vertical-icon.f6b30eed.svg";